import { useDispatch, useSelector } from "react-redux";
import { clearCart } from "../../ducks/shoppingCartSlice";
import { clearCheckout, submitCheckoutTotem } from "../../ducks/checkoutSlice";
import useGoTo from "../../hooks/useGoTo";
import useSubmitSelfcheckout from "../../hooks/useSubmitSelfcheckout";
import SelfCheckoutQRCodeForm from "./SelfCheckoutQRCodeForm";

// QR Code: o cliente pede no celular e paga no POS digitando o número do
// pedido, mostrado na tela de status. O celular é dele, então limpa o
// checkout inteiro (e não só as respostas do totem).
export default function SelfCheckoutQRCode() {
  const dispatch = useDispatch();
  const goTo = useGoTo();
  const selfcheckoutConfig = useSelector(
    (state) => state.shop.selfcheckoutConfigs[0] ?? {},
  );

  const submit = useSubmitSelfcheckout(async () => {
    const order = await dispatch(submitCheckoutTotem());
    dispatch(clearCart());
    dispatch(clearCheckout());
    goTo(`/status/${order.shortReference}`);
  });

  return (
    <SelfCheckoutQRCodeForm
      askForLocation={selfcheckoutConfig.askForLocation}
      askForName={selfcheckoutConfig.askForName}
      askForCpf={selfcheckoutConfig.askForCpf}
      onSubmit={submit}
    />
  );
}
